import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProductCodeQuery, ScreenType } from '@fgb/core';
import { ProductCode } from 'src/app/shared/utilities/product-code';

@Component({
  selector: 'fgb-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent implements OnInit {
  @Input() backButtonLink?: string;
  @Input() pageTitle: string;
  @Input() showQr: boolean = true;
  @Input() showFooter: boolean = true;
  @Input() isHomePage: boolean = false;

  season: boolean;
  premium: boolean;
  sgb: boolean;

  screenType = ScreenType;

  constructor(
    private productCodeQuery: ProductCodeQuery,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit() {
    this.season = this.productCodeQuery.currentUserIsProductCode(ProductCode.Season);
    this.premium = this.productCodeQuery.currentUserIsProductCode(ProductCode.Premium);
    this.sgb = this.productCodeQuery.currentUserIsProductCode(ProductCode.SGB);
  }

  gotoWallet() {
    this.router.navigate(['/rewards/wallet']);
  }

  goBack() {
    if (this.backButtonLink) {
      this.router.navigate([this.backButtonLink]);
    } else {
      this.location.back();
    }
  }
}
